<template>
    <PlanbordGridRow class="commentInfo" v-if="hasEditPermission || roster.comments!.length > 0">
        <PlanbordGridLeftDataColumns class="commentLeftColumns">
            <PlanbordGridCell>
                <span @click="showNewCommentDialog" class="newComment" v-if="hasEditPermission">
                    Nieuwe opmerking
                    <i class="icon edit" />
                </span>
            </PlanbordGridCell>
            <PlanbordFunctionCell />
            <PlanbordCommentCell />
            <PlanbordStampStartDateCell />
        </PlanbordGridLeftDataColumns>
        <div class="commentGrid">
            <RosterComment
                v-for="comment in roster.comments"
                :key="comment.id!"
                :permissions="permissions"
                :comment="comment"
                :firstVisibleDate="rosterViewSettings.startDate"
                @showCommentDialog="showCommentDialog"
            />
        </div>
    </PlanbordGridRow>
</template>

<script lang="ts">
    import {UserPermissions} from '@/types/enums/UserPermissions';
    import PlanbordGridRow from '@/components/Planbord/PlanbordGridRow.vue';
    import PlanbordFunctionCell from '@/components/Planbord/PlanbordFunctionCell.vue';
    import PlanbordGridLeftDataColumns from '@/components/Planbord/PlanbordGridLeftDataColumns.vue';
    import PlanbordGridCell from '@/components/Planbord/PlanbordGridCell.vue';
    import PlanbordCommentCell from '@/components/Planbord/PlanbordCommentCell.vue';
    import {RosterData, PermissionsForRoster} from '@/types/types';
    import RosterComment from '@/components/Planbord/RosterComment.vue';
    import {RosterViewSettings} from '@/types';
    import {RosterComment as RosterCommentModel} from '@cquential/api';
    import Dates from '@cquential/date-utils';
    import RosterCommentModal from '@/components/modals/RosterCommentModal.vue';
    import PlanbordStampStartDateCell from '@/components/Planbord/PlanbordStampStartDateCell.vue';
    import {Component, Vue, Prop} from 'vue-facing-decorator';

    @Component({
        components: {
            PlanbordGridRow,
            PlanbordFunctionCell,
            PlanbordGridLeftDataColumns,
            PlanbordGridCell,
            PlanbordCommentCell,
            RosterComment,
            PlanbordStampStartDateCell,
        },
    })
    export default class RosterComments extends Vue {
        @Prop({required: true}) public roster!: RosterData;
        @Prop({required: true}) public permissions!: Record<number, PermissionsForRoster>;
        @Prop({required: true}) public rosterViewSettings!: RosterViewSettings;

        public get hasEditPermission(): boolean {
            return this.permissions[this.roster.rosterId] && this.permissions[this.roster.rosterId][UserPermissions.EditRosterComment];
        }

        public showNewCommentDialog(): void {
            this.showCommentDialog({
                id: undefined,
                beginDate: this.rosterViewSettings.startDate,
                endDate: Dates.Utils.addDays(this.rosterViewSettings.startDate, 6),
                comment: '',
                userId: null,
                rosterIds: [this.roster.rosterId],
            });
        }

        public showCommentDialog(comment: RosterCommentModel): void {
            /** @see RosterCommentModal.openModal() */
            // @ts-expect-error TS2339
            RosterCommentModal.__vfdConstructor.openModal(comment);
        }
    }
</script>

<style lang="scss" scoped>
    .commentInfo {
        grid-auto-flow: column;

        --cell-background-color: var(--main-background-color);
    }

    .commentLeftColumns {
        margin-bottom: -1px;
    }

    .commentGrid {
        display: grid;
        grid-column: calc(var(--left-non-day-columns, 0) + 1) / calc(0 - calc(var(--right-non-day-columns, 0) + 1));
        grid-template-columns: subgrid;
        margin-bottom: -1px;
        grid-auto-flow: column;
    }

    .newComment {
        cursor: pointer;
        display: flex;
        align-items: center;

        .icon {
            margin-left: 0.5rem;
            background: var(--button-teal);
        }
    }
</style>
